'use client';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../ui/heading';
import { Button } from '../ui/button';

import { HiOutlineArrowCircleDown } from 'react-icons/hi';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Paragraph } from '../ui/paragraph';

export function Ebook({
  subtitle,
  title,
  description,
  image,
}: {
  subtitle: string;
  title: string;
  description: string;
  image: string;
}) {
  const { t } = useTranslations();

  return (
    <section className={cn('custom-section', 'ea-section-medium__top', 'ea-section-big__bottom')}>
      <div
        className={cn(
          'custom-container',
          'relative flex flex-col items-center justify-start gap-0 overflow-hidden rounded-[24px] bg-[#004080] p-0 sm:gap-12 sm:p-8 md:flex-row md:items-center md:p-10 lg:gap-16 lg:p-16',
        )}
      >
        <Image
          src={image}
          alt={title}
          width={0}
          height={0}
          className="aspect-square w-full max-w-[316px] object-cover object-center"
          sizes="100vw"
        />
        <div className="flex w-full max-w-[640px] flex-col items-start justify-start gap-8 p-6">
          <Heading
            subtitle={subtitle}
            title={title}
            className={{ title: 'text-white', container: 'w-full', subtitle: 'text-white' }}
          />
          <Paragraph
            tag="p"
            innerHtml={description}
            className="w-full text-opacity-80"
            color="white"
          />
          <Button asChild variant={'white'}>
            <Link prefetch={false} href={'/'} target="_blank" rel="noopener noreferrer">
              <HiOutlineArrowCircleDown size={20} /> {t('text3320')}
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
